export enum ToastVariant {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO'
}

export interface IToastContent {
  body: string;
  title: string;
  id: string;
  variant: ToastVariant;
  timeout?: number;
  dataTest?: string;
}
